module.exports = __webpack_public_path__ + "static/media/NewsPaper_Wasabi.a9902486.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/NewsPaper_Wasabi.png
// module id = 284
// module chunks = 0